/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  codigoEtapa: string;
}

export function useBaixarChecklist() {
  const postData = async (props: Props) => {
    const ANEXAR_LAUDO = `${backofficeEnviroment}/common/backoffice/baixar-checklist/v1`;
    const { data } = await instance.put(ANEXAR_LAUDO, {
      idOportunidade: props.idOportunidade,
      codigoEtapa: props.codigoEtapa,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Checklist baixado com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao baixar checklist. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
